import { getAmplitudeInstance } from '../amplitudeHelpers';
import ExploreMapViewAdjustmentTaken from '../enums/ExploreMapViewAdjustmentTaken';

type logMapViewAdjustmentClickedParams = {
  action_taken: ExploreMapViewAdjustmentTaken;
};

/**
 * User zooms in/out, re-orients the compass, clicks 3d or 2d map, clicks map layer cta, or clicks current location cta. Currently explore map on web only.
 * @param params - Attributes to log with the amplitude event
 * @param params.action_taken - The action a user took to adjust the map view.
 */
const logMapViewAdjustmentClicked = ({ action_taken }: logMapViewAdjustmentClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('map view adjustment clicked', { 'action taken': action_taken }, callback);
};

export default logMapViewAdjustmentClicked;
